import { EKwikUIStepperOrientation } from "./stepper.definitions";

export const DEFAULT_VALUES = {
  steps: [],
  orientation: EKwikUIStepperOrientation.HORIZONTAL,
  activeItemIndex: 0,
  clickable: false,
  id: "stepper"
};

export const VALIDATE_KEY_VALUES = {
  steps: true,
  orientation: true,
  activeItemIndex: true,
  clickable: true,
  id: true
};
